<button type="button" class="btn btn-light btn-sm w-100 p-1 text-left" data-toggle="modal" [attr.data-target]="'#notes-modal_' + (key || '')" title="Show Alerts & Notes" id="btn-note-alert-contact_{{key || ''}}">
    <span class="uil-comment-message"></span>
</button>
<div id="notes-modal_{{key || ''}}" class="modal fade" tabindex="-1" role="dialog">
    <div class="modal-dialog min-w-modal modal-right">
        <div class="modal-content h-100">
            <div class="modal-header">
                <h5 class="text-light">{{ words[language][ 'notesAlerts' ] }}</h5>
                <form [formGroup]="filters" class="form-inline">
                    <div class="form-group">
                        <select class="form-control form-control-sm text-light" id="notes-activity-filter" formControlName="activity">
                            <option value="">All activities</option>
                            @for (activity of activityFilters; track activity) {
                                <option [value]="activity.key">{{activity.display}}</option>
                            }
                        </select>
                    </div>
                    @if (multi) {
                        <div class="form-group">
                            <div class="custom-control custom-switch">
                                <input type="checkbox" class="custom-control-input" id="allSwitch" formControlName="all" />
                                <label class="custom-control-label text-light" for="allSwitch">All</label>
                            </div>
                        </div>
                    }
                </form>
                <button type="button" class="close text-light" data-dismiss="modal" title="close">×</button>
            </div>
            <div class="modal-body d-flex flex-column justify-content-between">
                <!-- views notes -->
                <div class="text-center p-2 overflow-auto alert-window"
                    [ngClass]="{'expanded-mid': windowOpen,'expanded-all': !windowOpen}" (scroll)="scrolled($event)">
                    <!-- Portlet card -->
                    @for (note of notes; track note; let i = $index) {
                    <div class="card note" [ngClass]="{'note-alert': note.alert}">
                        <div class="card-body fade show">
                            @if (noteSelected != note.id) {
                                <div class="note-content">
                                    <div class="icon-box">
                                        <span class="material-icons">{{icon(note.activity)}}</span>
                                    </div>
                                    <div class="text-wrap" (click)="setNote(note, i)" title="Double click to edit">{{note.content}}</div>
                                    @if (security.permitted('contacts', 'notes alerts', 'discard')) {
                                        <button class="btn btn-xs btn-link" (click)="discard($event, note.id, i)"
                                            title="Delete">
                                            @if (!loading) {
                                                <span class="dripicons-trash text-danger"></span>
                                            }
                                        </button>
                                    }
                                </div>
                            }
                            <!-- in case note selected -->
                            @if (noteSelected != note.id) {
                            <div class="note-meta">
                                <div class="info-text">{{note.posted | date:'short'}}</div>
                                <div class="info-text">{{note.creator}}</div>
                                @if (note.modifier && (note.modifier != note.creator)) {
                                <div class="info-text">{{note.modifier}} <span class="text-muted">(edited)</span></div>
                                }
                            </div>
                            }
                            <!-- in case editing -->
                            @if (noteSelected==note.id) {
                            <div>
                                <form [formGroup]="form" class="mod-note-box">
                                    <div class="form-group">
                                        <textarea class="form-control text-dark" id="editable-textarea" rows="5"
                                            formControlName="content"></textarea>
                                    </div>
                                    <div class="form-inline">
                                        <div class="form-group">
                                            <div class="form-check">
                                                <input type="checkbox" class="form-check-input" id="important"
                                                    formControlName="alert">
                                                <label class="form-check-label"
                                                    for="important">{{words[language]['markAsImportant'] }}</label>
                                            </div>
                                        </div>
                                        <div class="form-group">
                                            <select class="form-control form-control-sm" id=""
                                                formControlName="activity">
                                                @for (activity of availableActivities; track activity) {
                                                <option [value]="activity.key">{{activity.display}}</option>
                                                }
                                            </select>
                                        </div>
                                        <div class="form-group">
                                            <button class="btn btn-link btn-sm" (click)="reset()">
                                                <span class="text-danger">{{ words[language][ 'cancel' ] }}</span>
                                            </button>
                                        </div>
                                        <div class="form-group">
                                            <button class="btn btn-primary btn-sm" [disabled]=" form.invalid"
                                                (click)="update($event)">
                                                @if (loading) {
                                                <span class="spinner-grow spinner-grow-sm mr-1 ml-auto"
                                                    role="status"></span>
                                                }{{ words[language][ 'save' ] }}
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                            }
                        </div> <!-- end card-->
                    </div>
                    }
                </div>
                <!-- add new note -->

                <div class="row">
                    <div class="col-md-12">
                        <!-- Portlet card -->
                        <div class="card bg-light add-note-box">
                            <div class="card-body">
                                <h5 class="card-title" (click)="windowOpen=!windowOpen" data-toggle="collapse" href="#addNoteCollapse" role="button" aria-expanded="false" aria-controls="addNoteCollapse">
                                    <button class="btn-light btn btn-block">{{words[language][ 'addNote' ]}}</button>
                                </h5>

                                <div id="addNoteCollapse" class="collapse">
                                    <form [formGroup]="information">
                                        <div class="form-group">
                                            <textarea class="form-control" id="note-content" rows="5"
                                                formControlName="content"></textarea>
                                        </div>
                                        <div class="form-inline">
                                            <div class="form-group">
                                                <div class="form-check">
                                                    <input type="checkbox" class="form-check-input" id="important"
                                                        formControlName="alert">
                                                    <label class="form-check-label"
                                                        for="important">{{words[language]['markAsImportant'] }}</label>
                                                </div>
                                            </div>
                                            <div class="form-group">
                                                <select class="form-control form-control-sm" id=""
                                                    formControlName="activity">
                                                    @for (activity of availableActivities; track activity) {
                                                    <option [value]="activity.key">{{activity.display}}</option>
                                                    }
                                                </select>
                                            </div>
                                            <div class="form-group">
                                                <button class="btn btn-primary btn-sm" [disabled]="information.invalid"
                                                    (click)="save($event)">
                                                    @if (loading) {
                                                    <span class="spinner-grow spinner-grow-sm mr-1 ml-auto"
                                                        role="status"></span>
                                                    }{{ words[language][ 'save' ] }}
                                                </button>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div> <!-- end card-->
                    </div><!-- end col -->
                </div>
            </div>
        </div><!-- /.modal-content -->
    </div><!-- /.modal-dialog -->
</div><!-- /.modal -->